// Admin

import './App.css';

import AdminStart from "./components/AdminStart";
import AdminLogin from './components/AdminLogin ';
import AdminCategories from './components/AdminCategories';
import PetParentTable from './components/PetParentTable';
import PetAdopterTable from './components/PetAdopterTable';
import PetParentCard from './components/PetParentCard';
import PetAdopterCard from './components/PetAdopterCard';

// Users

import Login from "./components/Login";
import Signup from "./components/Signup";
import ForgotPassword from './components/ForgotPassword';
import ResetPasswordForm from './components/ResetPasswordForm';
import Home from "./components/Home";
import Family from './components/Family';
import Info from "./components/Info";
import AboutUs from './components/AboutUs';
import Contact from './components/Contact';
import Profile from './components/Profile';
import UserProfile from './components/UserProfile';
import EditProfile from './components/EditProfile';
import AdoptForm from './components/AdoptForm';
import SupportUs from './components/SupportUs';
import PetData from './components/PetData';
import PetParentData from './components/PetParentData';
import { Route, Routes } from "react-router-dom";
import ForgotPasswordOTP from './components/ForgotPasswordOTP';




function App() {
  return (
    <>

      <Routes>

        {/* Admin */}
        <Route path="/adminstart" element={<AdminStart />} />
        <Route path="/adminlogin" element={<AdminLogin />} />
        <Route path="/adminCategories" element={<AdminCategories />} />
        <Route path="/petParentTable" element={<PetParentTable />} />
        <Route path="/petAdopterTable" element={<PetAdopterTable />} />
        <Route path="/petParentCard/:email" element={<PetParentCard />} />
        <Route path="/petAdopterCard/:email" element={<PetAdopterCard />} />

        {/* Users */}
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/adoptform/:petid" element={<AdoptForm />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgotPassword" element={<ForgotPassword />} />
        <Route path="/forgotPasswordOTP" element={<ForgotPasswordOTP />} />
        <Route path="/resetPasswordForm" element={<ResetPasswordForm />} />
        <Route path="/family/:category" element={<Family />} />
        <Route path="/info/:petid"  element={<Info />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/userProfile/:email" element={<UserProfile />} />
        <Route path="/editProfile/:email" element={<EditProfile />} />
        <Route path="/supportus" element={<SupportUs />} />
        <Route path="/petData" element={<PetData />} />
        <Route path="/petParentData" element={<PetParentData />} />
        {/* <Route path="*" element={<Error />} />  */}

      </Routes>


    </>
  );
}

export default App;
